import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function DataMapper({ mapping = {} }) {
	const [appIsMounted, setAppIsMounted] = useState(null);

	useEffect(() => {
		/*
			Create array of projects,utils with configuration that has utils set to true:
			[{
				utils: <pending promise>
				project: 'blast'
			}]
		*/
		const projectUtils = [];

		Object.entries(mapping).forEach(
			([project, { configuration: { utils = false } = {} }]) =>
				utils &&
				projectUtils.push({
					utils: import(`../utils/${project}/utils`),
					project
				})
		);

		async function loadFiles() {
			/*
				Get resolved utils modules
			*/
			const modules = await Promise.all(
				projectUtils.map(async (promise) => promise.utils)
			);

			/*
				Loop through modules and add the utils
			*/
			modules.forEach(({ project, ...functions }) => {
				window.DDC.WidgetData['ws-tagging'].mapping[project].utils =
					functions;
			});

			const { initIfWsTaggingReady } = await import(
				'../utils/dataMapper'
			);
			initIfWsTaggingReady();
			setAppIsMounted(true);
		}
		loadFiles();
	}, [mapping]);

	return appIsMounted ? <span data-testid="DataMapper" /> : null; // placholder is so we can grab this during unit testing
}

DataMapper.propTypes = {
	mapping: PropTypes.objectOf(PropTypes.object)
};
